<!-- 
	For now this modal will be manually triggered for specific dates 
	with custom content and will be only seen once after launch.
	Content and translations will be customized when it needs to be used,
	that's why for now it looks like this for test view.
-->

<script lang="ts">
	import { Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher, onMount } from 'svelte';
	import { mobile } from 'src/services/mobile-rework';
	import { format, locale } from 'svelte-i18n';
	import ButtonStar from './ButtonStar.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	import ButtonShopNow from './ButtonShopNow.svelte';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { profile_data, user_data } from 'src/stores/account/user';

	export let showModal = false;
	export let priority = 100;
	export let phase = 1;

	const dispatch = createEventDispatcher();

	let title = '';
	let src = '';
	let heading = '';
	let text = '';
	let navigationLink = '';
	$: {
		if (phase === 1) {
			title = $format('title_black_friday_phase_1', {
				default: 'Black Friday VIP Access',
			});
			src = './images/shelly-cube.png';
			heading = $format('heading_black_friday_phase_1', {
				default: 'Black Friday starts early for you',
			});
			text = $format('text_black_friday_phase_1', {
				default:
					'Join our VIP list for exclusive early access to Shelly’s Black Friday deals and special insider rewards. Hurry up the registration closes on 19 November!',
			});
			navigationLink = `https://www.shelly.com/${['de', 'fr', 'it'].includes($locale) ? `${$locale}/` : ''}pages/black-friday?utm_source=shellyapp&utm_medium=referral&utm_campaign=black_friday`;
		} else {
			title = $format('title_modal_black_friday', {
				default: 'Exclusive Black Friday',
			});
			src = './images/confetti-discount.png';
			heading = $format('alert_heading_black_friday_phase_2', {
				default: 'Black Friday starts now',
			});
			text = $format('text_black_friday_phase_2', {
				default:
					'Enjoy exclusive offers on all Shelly devices — our smart solutions for a more efficient, comfortable home are now more affordable than ever! Once it’s gone, it’s gone - shop Black Friday deals before 2 December!',
			});
			navigationLink = `https://www.shelly.com/${['de', 'fr', 'it'].includes($locale) ? `${$locale}/` : ''}pages/black-friday?utm_source=shellyapp&utm_medium=referral&utm_campaign=black_friday`;
		}
		if ($user_data?.timezone.startsWith('America/')) {
			navigationLink =
				'https://us.shelly.com/pages/black-friday?utm_source=shellyapp&utm_medium=referral&utm_campaign=black_friday';
		}
	}

	const closeModal = (e: CustomEvent | MouseEvent) => {
		if (showModal) {
			e.preventDefault();
			save_profile('promotions', {
				...$profile_data?.promotions,
				[phase === 1 ? 'blackFridayPhase1' : 'blackFridayPhase2']: new Date().getTime(),
			});
			dispatch('close');
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

<Modal {showModal} on:close={closeModal} {title} zIndex={priority}>
	<Container slot="content" padding="0">
		<div class="d-flex align-items-center flex-direction-column text-center">
			<img
				class={`width-full height-full ${phase === 2 ? 'mb-s' : ''}`}
				style="object-fit: contain;"
				alt="black-friday-2025"
				{src}
			/>
			<div class="wrapper">
				<Text element="h1" class="mb-m text-bold">
					{heading}
				</Text>
				<p class="sub-text mb-xl text-color-muted">
					{text}
				</p>
				{#if phase === 1}
					<ButtonStar {navigationLink} />
				{:else}
					<ButtonShopNow {navigationLink} />
				{/if}
				<Text class="mt-xl cursor-pointer" on:click={closeModal}
					>{capFirstChar($format('button_maybe_later', { default: 'Maybe later' }))}</Text
				>
			</div>
		</div>
	</Container>
</Modal>

<style>
	.wrapper {
		max-width: 450px;
	}

	.sub-text {
		font-size: 18px;
	}
</style>
